export function parseFirebaseError(code: string): string {
  // similar to what we have in portal
  switch (code) {
    case 'auth/invalid-email':
      return 'Email address is not valid';
    case 'auth/requires-recent-login':
      return 'A recent log in is required to do this change';
    case 'auth/weak-password':
      return 'Password is too weak';
    case 'auth/wrong-password':
      return 'The password you entered is incorrect.';
    case 'auth/email-already-in-use':
    case 'auth/account-exists-with-different-credential':
      return 'This email is already registered to an account.';
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
      return 'Incorrect email or password. Please try again.';
    case 'auth/user-not-found':
      return `Account doesn't exist`;
    case 'auth/invalid-action-code':
      return 'Your link is not valid. This link may have already been used.';
    case 'auth/expired-action-code':
      return 'Your link is expired.';
    case 'auth/user-disabled':
      return 'User disabled';
    case 'auth/popup-blocked':
      return 'Sign in Popup was blocked';
    case 'auth/cancelled-popup-request':
      return 'Cancelled popup request';
    case 'auth/too-many-requests':
      return 'Too many requests. Please try again later.';
    default:
      return code;
  }
}
